import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

// --- Helper type for custom props
type StyledLinkProps = {
  $active: boolean;
};

export const StyledTabs = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flex: 1,
});

// --- Forward custom prop correctly
export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== '$active',
})<StyledLinkProps>(({ $active }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '0 12px',
  cursor: 'pointer',
  color: $active ? COLORS.primary : COLORS.grey350,
  borderBottom: $active ? `2px solid ${COLORS.primary}` : 'none',
  textDecoration: 'none',

  '&:hover': {
    color: COLORS.primary,
  },
}));
